/**
 * Load the error page by throwing an error which forces a redirect.
 *
 * Use this composable anywhere outside of loading a page, e.g. on user input. During page loading you can skip the
 * redirect and directly use the error page with appropriate status code:
 *
 * ```
 * page = await mainStore.loadCmsErrorPage();
 * setResponseStatus(await useRequestEvent(nuxtApp), 404);
 * ```
 */
export const useCmsErrorPage = async (code = 404) => {
  const { $i18n } = useNuxtApp();
  const mainStore = useMainStore();

  if (!mainStore.errorPage) {
    await mainStore.loadCmsErrorPage();
  }

  // NOTE: Stack traces are not forwarded to the client for 404 errors or production builds
  // @see https://github.com/nuxt/nuxt/discussions/10578#discussioncomment-4887261
  throw createError({
    statusCode: code,
    message: `${$i18n.t('pages.error.message')} ${code}`,
    fatal: true,
  });
};
